// طير — Saudi cities & regions (latitude, longitude)
// Used by the interactive Trips map. Add more entries as needed.
export const SAUDI_CITY_COORDS = {
  "الرياض":     [24.7136, 46.6753],
  "جدة":        [21.4858, 39.1925],
  "مكة":        [21.3891, 39.8579],
  "مكة المكرمة":[21.3891, 39.8579],
  "المدينة":    [24.5247, 39.5692],
  "المدينة المنورة": [24.5247, 39.5692],
  "الدمام":     [26.4207, 50.0888],
  "الخبر":      [26.2172, 50.1971],
  "الظهران":    [26.2361, 50.0393],
  "الأحساء":    [25.3833, 49.5833],
  "الهفوف":     [25.3833, 49.5833],
  "الطائف":     [21.2703, 40.4158],
  "أبها":       [18.2164, 42.5053],
  "خميس مشيط":  [18.3000, 42.7333],
  "نجران":      [17.4924, 44.1277],
  "جازان":      [16.8892, 42.5511],
  "تبوك":       [28.3835, 36.5662],
  "حائل":       [27.5219, 41.6907],
  "بريدة":      [26.3260, 43.9750],
  "عنيزة":      [26.0906, 43.9875],
  "القصيم":     [26.3260, 43.9750],
  "الجبيل":     [27.0114, 49.6580],
  "ينبع":       [24.0895, 38.0618],
  "عرعر":       [30.9753, 41.0381],
  "سكاكا":      [29.9697, 40.2064],
  "الجوف":      [29.9697, 40.2064],
  "الباحة":     [20.0129, 41.4677],
  "رابغ":       [22.7986, 39.0347],
  "الخرج":      [24.1554, 47.3123],
  "المجمعة":    [25.9060, 45.3706],
  "الزلفي":     [26.2996, 44.8151],
  "الأفلاج":    [22.1500, 46.2500],
  "الدوادمي":   [24.5000, 44.3833],
  "شقراء":      [25.2500, 45.2500],
  "ضباء":       [27.3500, 35.7000],
  "الوجه":      [26.2440, 36.4636],
  "أملج":       [25.0537, 37.2653],
  "القريات":    [31.3315, 37.3628],
  "طريف":       [31.4118, 38.6516],
  "رفحاء":      [29.6202, 43.4906],
  "بيشة":       [19.9737, 42.6014],
  "الليث":      [20.1500, 40.2667],
  "القنفذة":    [19.1265, 41.0791],
  "صبيا":       [17.1489, 42.6237],
  "الخفجي":     [28.4326, 48.4906],
  "حفر الباطن": [28.4337, 45.9601],
  "النعيرية":   [27.4805, 48.4841],
  "رأس تنورة":  [26.6440, 50.1580],
  "دبي":        [25.2048, 55.2708],
  "أبوظبي":     [24.4539, 54.3773],
  "الشارقة":    [25.3463, 55.4209],
  "عجمان":      [25.4052, 55.5136],
  "رأس الخيمة": [25.7895, 55.9432],
  "الفجيرة":    [25.1288, 56.3265],
  "العين":      [24.2075, 55.7447],
  "المنامة":    [26.2285, 50.5860],
  "المحرق":     [26.2572, 50.6119],
  "الدوحة":     [25.2854, 51.5310],
  "الريان":     [25.2919, 51.4244],
  "مدينة الكويت": [29.3759, 47.9774],
  "حولي":       [29.3333, 48.0333],
  "مسقط":       [23.5880, 58.3829],
  "صلالة":      [17.0151, 54.0924],
  "صحار":       [24.3470, 56.7080],
};

/**
 * Look up coordinates for a Saudi city name. Returns null when unknown.
 */
export function coordsFor(cityName) {
  if (!cityName) return null;
  const key = cityName.trim();
  if (SAUDI_CITY_COORDS[key]) return SAUDI_CITY_COORDS[key];
  // fuzzy: try to find a key that starts with the city name
  const found = Object.keys(SAUDI_CITY_COORDS).find(
    (k) => k.startsWith(key) || key.startsWith(k)
  );
  return found ? SAUDI_CITY_COORDS[found] : null;
}

// Approximate Saudi Arabia geographic center — used as map default.
export const SAUDI_CENTER = [23.8859, 45.0792];
export const SAUDI_ZOOM = 5;
